export default function NotFound() {
	return (
		<div className="text-gray-300 mt-2 mb-2">
			<h1 className="text-red-400">Command not found</h1>
			<h1>Try: ls</h1>
		</div>
	);
}
